var _rect, _rect2, _text, _text2, _rect3, _text3, _text4, _path, _rect4, _text5, _text6, _rect5, _text7, _text8, _rect6, _text9, _text0, _path2, _path3, _path4, _rect7, _text1, _text10, _text11, _rect8, _text12, _text13, _text14, _rect9, _text15, _text16, _text17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraAgileHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 720,
    viewBox: "0 0 1200 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    rx: 36,
    fill: "#F8FBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 42,
    width: 1100,
    height: 636,
    rx: 28,
    fill: "white",
    stroke: "#D9E4F2",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 108,
    fill: "#13213F",
    fontFamily: "Arial, sans-serif",
    fontSize: 38,
    fontWeight: 700
  }, "Agile Hierarchy in JIRA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 148,
    fill: "#56657A",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "How epic, story, task, sub-task, and bug connect in a real QA project")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 195,
    width: 1020,
    height: 90,
    rx: 24,
    fill: "#173E9F"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 245,
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "Epic")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 273,
    fill: "#E8F0FF",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Payment Module")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 285V334",
    stroke: "#9FB7E3",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 340,
    width: 300,
    height: 112,
    rx: 22,
    fill: "#EFF5FF",
    stroke: "#B7CBEA",
    strokeWidth: 3
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 387,
    fill: "#173E9F",
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700
  }, "Story 1")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 417,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "User should pay using UPI")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 340,
    width: 300,
    height: 112,
    rx: 22,
    fill: "#FFF5EA",
    stroke: "#F5C98D",
    strokeWidth: 3
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 387,
    fill: "#C7630A",
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700
  }, "Story 2")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 417,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "User should pay using card")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 785,
    y: 340,
    width: 300,
    height: 112,
    rx: 22,
    fill: "#EEF9F2",
    stroke: "#A8D8BE",
    strokeWidth: 3
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 815,
    y: 387,
    fill: "#1A7F52",
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700
  }, "Story 3")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 815,
    y: 417,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "User should view payment history")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265 452V505",
    stroke: "#9FB7E3",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M600 452V505",
    stroke: "#9FB7E3",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M935 452V505",
    stroke: "#9FB7E3",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 510,
    width: 350,
    height: 128,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#DDE7F4",
    strokeWidth: 3
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 555,
    fill: "#173E9F",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Task / Sub-task")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 590,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Create UPI UI")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 618,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Add validation and test data")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 510,
    width: 280,
    height: 128,
    rx: 22,
    fill: "#FFF8F1",
    stroke: "#F3D5A9",
    strokeWidth: 3
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 555,
    fill: "#C7630A",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Bug")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 590,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "UPI payment failing for PhonePe")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 618,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Severity: Critical | Priority: High")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 510,
    width: 350,
    height: 128,
    rx: 22,
    fill: "#F3FBF6",
    stroke: "#BFE2CF",
    strokeWidth: 3
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 790,
    y: 555,
    fill: "#1A7F52",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "QA Outcome")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 790,
    y: 590,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Retest payment flow")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 790,
    y: 618,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Close story only after verification")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraAgileHierarchy);
export default __webpack_public_path__ + "static/media/jira-agile-hierarchy.4601fca405add0fbe9d5ac040e813b6b.svg";
export { ForwardRef as ReactComponent };